<template>
    <button
        class="mr:mb-2 mr:rounded-lg px-6 mr:md:px-8 mr:py-6 mr:flex mr:items-center mr:bg-white mr:shadow-2-8 mr:shadow-black/10 mr:outline-none mr:w-full mr:box-border mr:text-left"
        @click="emits('click')"
    >
        <component
            :is="iconComponents[type]"
            data-cy="notification-item-icon"
            :class="iconStyles[type] || ''"
            class="mr:w-42 mr:min-w-42 mr:h-42"
        />

        <span
            data-cy="notification-item-message"
            :class="messageStyles[type] || ''"
            class="mr:ml-4 mr:font-omnes-medium"
        >
            {{ message }}
        </span>
    </button>
</template>

<script setup lang="ts">
import IconMaterialCheck from '@src/images/icon-material-check.svg?component'
import IconMaterialExclamationMark from '@src/images/icon-material-exclamation-mark.svg?component'
import IconMaterialInfo from '@src/images/icon-material-info.svg?component'

const emits = defineEmits(['click'])

const { type } = defineProps<{
    type: 'success' | 'error' | 'info'
    message: string
}>()

const messageStyles = {
    success: 'mr:text-base-grey-5',
    error: 'mr:text-red',
    info: 'mr:text-base-grey-5'
}

const iconStyles = {
    success: 'mr:text-brand-a',
    error: 'mr:text-red',
    info: 'mr:text-base-grey-5'
}

const iconComponents = {
    success: IconMaterialCheck,
    error: IconMaterialExclamationMark,
    info: IconMaterialInfo
}
</script>
